import {
  boundedTextSchema,
  localOggAudioReferenceSchema
} from "@/domain/schemas";

export interface CurriculumVoiceCue {
  readonly audioPath: string;
  readonly text: string;
}

export function defineCurriculumVoiceCue(
  audioPath: string,
  text: string
): CurriculumVoiceCue {
  return {
    audioPath: localOggAudioReferenceSchema.parse(audioPath),
    text: boundedTextSchema(600).parse(text)
  };
}
